import React from 'react';
import styled from "@emotion/styled";

const LabelWrapper = styled.div`
    font-family: Metropolis;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height */
    
    color: var(--color-gray-600);
`;

/**
 *  Simple wrapper component to get label style
 * @param props
 * @returns {*}
 */
export default (props) => (<LabelWrapper>{props.children}</LabelWrapper>);
